module.exports = __webpack_public_path__ + "static/sales-7dcca79cf6171e58f9a0c3a10a29bfaf.jpg";